import PropTypes from "prop-types";
import React from "react";

import {
  contentClass,
  headerClass,
  hideClass,
  labelClass,
  iconClassExpanded,
  iconClassCollapsed,
} from "./constants";

class Collapsible extends React.Component {
  static get propTypes() {
    return {
      children: PropTypes.node,
      className: PropTypes.string,
      label: PropTypes.node,
    };
  }

  static get defaultProps() {
    return {
      className: "",
      label: "",
    };
  }

  constructor() {
    super();

    this.state = {
      expanded: false,
    };

    this.toggle = this.toggle.bind(this);
  }

  toggle() {
    this.setState({ expanded: !this.state.expanded });
  }

  render() {
    const { children, label, className, ...attrs } = this.props;
    const { expanded } = this.state;

    let caretClass = iconClassExpanded;
    let allContentClass = contentClass;
    if (!expanded) {
      caretClass = iconClassCollapsed;
      allContentClass = `${contentClass} ${hideClass}`;
    }
    const iconClasses = `fa ${caretClass}`;

    return (
      <div className={`ui-collapsible ${className}`} {...attrs}>
        <div onClick={this.toggle} className={headerClass}>
          <i className={iconClasses} />
          <span className={labelClass}>{label}</span>
        </div>

        <div className={allContentClass}>{children}</div>
      </div>
    );
  }
}

export default Collapsible;
export { Collapsible };
